export default function filterByDisplayIf(userChoiceValues) {
  return (displayIf) => {
    if (!displayIf) {
      return true;
    }

    const filterBy = Object.keys(displayIf);

    return filterBy.every((userChoiceField) => {
      const fieldValue = userChoiceValues[userChoiceField];

      if (displayIf[userChoiceField].includes) {
        return displayIf[userChoiceField].includes.includes(fieldValue);
      }

      if (displayIf[userChoiceField].notIncludes) {
        return !displayIf[userChoiceField].notIncludes.includes(fieldValue);
      }

      return true;
    });
  };
}
